var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import moment from 'moment';
import { getPeriodDateFromUntil } from '@/shared/components/PeriodButtonGroup';
import { defaultFilters } from './IntraCompanyFilters';
var initPeriod = function (filters) {
    if (!filters.period)
        return filters;
    return __assign(__assign({}, filters), getPeriodDateFromUntil(filters.period));
};
export var initialFilters = function (sessionFilters, stateFilters) {
    try {
        if (stateFilters) {
            var combinedFilters = __assign(__assign({}, defaultFilters), stateFilters);
            if (JSON.stringify(combinedFilters) !== JSON.stringify(defaultFilters))
                return initPeriod(combinedFilters);
        }
        if (!sessionFilters)
            return __assign({}, defaultFilters);
        if (typeof sessionFilters === 'string') {
            sessionFilters = JSON.parse(sessionFilters);
        }
        if (sessionFilters) {
            if (typeof sessionFilters.dateFrom === 'string')
                sessionFilters.dateFrom = moment.utc(sessionFilters.dateFrom);
            if (typeof sessionFilters.dateUntil === 'string')
                sessionFilters.dateUntil = moment.utc(sessionFilters.dateUntil);
            return initPeriod(__assign(__assign({}, defaultFilters), sessionFilters));
        }
    }
    catch (e) {
        console.error(e);
        return __assign({}, defaultFilters);
    }
};
